import React from 'react'
import Header from '../components/header/Header'
import Contact from '../components/contact/Contact'
import FloatingButton from '../components/bottomtotop/FloatingButton'
import Footer from '../components/footer/Footer'

const ContactUs = () => {
  return (
    <div>
        <Header />
        <Contact />
        <FloatingButton />
        <Footer />
    </div>
  )
}

export default ContactUs